import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getDate = date => {
  return capitalizeFirstLetter(dayjs(date).format('dddd DD MMMM'))
}

export const getTime = date => {
  return dayjs(date).format('HH:mm')
}

export const getDateTime = date => {
  return `${getDate(date)} à ${getTime(date)}`
}

export const getDateTime2 = (dateA, dateB) => {
  return `${getDate(dateA)} de ${getTime(dateA)} à ${getTime(dateB)}`
}

/**
 * ÉPOQUE MURALE des créneaux de conférence (`EventConferenceSlots.startAt/endAt`) : l'heure
 * saisie au BO est stockée exprimée en UTC et se relit en UTC, jamais dans le fuseau du
 * participant. Voir api/src/helpers/wallEpoch.js. Réservé aux créneaux : les jours de
 * l'événement et les articles gardent `getDate`.
 */
export const getWallDateTime2 = (dateA, dateB) => {
  const a = dayjs.utc(dateA)
  const b = dayjs.utc(dateB)
  return `${capitalizeFirstLetter(a.format('dddd DD MMMM'))} de ${a.format('HH:mm')} à ${b.format('HH:mm')}`
}
